import { Location } from 'history';
import {
    BazaarCounts,
    HomePageState,
    StrollerBrandOption,
} from 'mk2/apps/home/containers/Home2/Home2.reducers';
import { Count } from 'mk2/components/NotificationsBadge';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

///////////////////////////////////////////////////////////////////
// Homepage load

export const HOME_LOAD_TRIGGER = 'HOME_LOAD_TRIGGER';
export interface HomeLoadTriggerAction {
    readonly type: typeof HOME_LOAD_TRIGGER;
    readonly currentUrl: Location;
    readonly page?: number;
    readonly fromPage?: number;
}

export const HOME_LOAD_REQUEST = 'HOME_LOAD_REQUEST';
export interface HomeLoadRequestAction extends APIRequestAction {
    readonly type: typeof HOME_LOAD_REQUEST;
    readonly brandDaysCampaign: string;
    readonly page?: number;
    readonly fromPage?: number;
}
export interface HomeLoadNormalizedResponse extends NormalizedResponse {
    readonly result: {
        forum: { posts: number[]; };
        brandDays: { posts: number[]; campaign: number; };
        contests: { posts: number[]; topic: number; };
        photoblog: { posts: number[]; };
        homepage: { posts: number[]; nextPage: number | null; };
        counselling: { counsellings: number[]; };
        strolleropedia: { strollers: number[]; };
        strollerbase: { numStrollers: number; };
        eshopPills: { eshopPills: string[] };
        bazaar: { counts: BazaarCounts; }
        lastVisitCountFriends: Count | '' | null;
        place: HomePageState['place'];
        strollerArticles: number[];
        strollerReviews: number[];
        reviewsStrollers: number[];
        wikiExperiences: number[];
        strollers: number[];
        strollersPreviewPhotoMap: Record<number, number>;
        strollersPhotos: number[];
    };
}
export const HOME_LOAD_SUCCESS = 'HOME_LOAD_SUCCESS';
export interface HomeLoadSuccessAction extends APISuccessAction<HomeLoadNormalizedResponse> {
    readonly type: typeof HOME_LOAD_SUCCESS;
    readonly page?: number;
    readonly fromPage?: number;
}
export const HOME_LOAD_FAILURE = 'HOME_LOAD_FAILURE';
export interface HomeLoadFailureAction extends APIFailureAction {
    readonly type: typeof HOME_LOAD_FAILURE;
    readonly page?: number;
    readonly fromPage?: number;
}

export const homeLoadTrigger =
    (currentUrl: Location, page: number, fromPage: number): HomeLoadTriggerAction => ({
        type: HOME_LOAD_TRIGGER, currentUrl, page, fromPage,
    });
export const homeLoadApi = {
    request: (brandDaysCampaign: string, page: number, fromPage: number): HomeLoadRequestAction => ({
        type: HOME_LOAD_REQUEST, brandDaysCampaign, page, fromPage,
    }),
    success: (page: number, fromPage: number, response: HomeLoadNormalizedResponse): HomeLoadSuccessAction => ({
        type: HOME_LOAD_SUCCESS, page, fromPage, response,
    }),
    failure: (error: any, page: number, fromPage: number): HomeLoadFailureAction => ({
        type: HOME_LOAD_FAILURE, page, fromPage, error,
    }),
};

///////////////////////////////////////////////////////////////////
// Homepage checkout

export const HOME_CHECKOUT_TRIGGER = 'HOME_CHECKOUT_TRIGGER';
export interface HomeCheckoutTriggerAction {
    readonly type: typeof HOME_CHECKOUT_TRIGGER;
    readonly data: string[];
}
export const homeCheckoutTrigger =
    (data: string[]): HomeCheckoutTriggerAction => ({
        type: HOME_CHECKOUT_TRIGGER, data,
    });

///////////////////////////////////////////////////////////////////
// Homepage load next page

export const HOME_LOAD_PAGE_TRIGGER = 'HOME_LOAD_PAGE_TRIGGER';
export interface HomeLoadPageTriggerAction {
    readonly type: typeof HOME_LOAD_PAGE_TRIGGER;
    readonly page: number;
}
export const HOME_LOAD_PAGE_REQUEST = 'HOME_LOAD_PAGE_REQUEST';
export interface HomeLoadPageRequestAction extends APIRequestAction {
    readonly type: typeof HOME_LOAD_PAGE_REQUEST;
    readonly page: number;
}
export interface HomeLoadPageNormalizedResponse extends NormalizedResponse {
    readonly result: {
        homepage: { posts: number[]; nextPage: number | null; };
    };
}
export const HOME_LOAD_PAGE_SUCCESS = 'HOME_LOAD_PAGE_SUCCESS';
export interface HomeLoadPageSuccessAction extends APISuccessAction<HomeLoadPageNormalizedResponse> {
    readonly type: typeof HOME_LOAD_PAGE_SUCCESS;
    readonly page: number;
}
export const HOME_LOAD_PAGE_FAILURE = 'HOME_LOAD_PAGE_FAILURE';
export interface HomeLoadPageFailureAction extends APIFailureAction {
    readonly type: typeof HOME_LOAD_PAGE_FAILURE;
    readonly page: number;
}

export const homeLoadPageTrigger =
    (page: number): HomeLoadPageTriggerAction => ({
        type: HOME_LOAD_PAGE_TRIGGER, page,
    });
export const homeLoadPageApi = {
    request: (page: number): HomeLoadPageRequestAction => ({
        type: HOME_LOAD_PAGE_REQUEST, page,
    }),
    success: (page: number, response: HomeLoadPageNormalizedResponse): HomeLoadPageSuccessAction => ({
        type: HOME_LOAD_PAGE_SUCCESS, page, response,
    }),
    failure: (page: number, error: any): HomeLoadPageFailureAction => ({
        type: HOME_LOAD_PAGE_FAILURE, page, error,
    }),
};

///////////////////////////////////////////////////////////////////
// Homepage load stroller brands

export interface HomeStrollersLoadBrandsNormalizedResponse extends NormalizedResponse {
    readonly result: {
        brands: StrollerBrandOption[];
    };
}


///////////////////////////////////////////////////////////////////
// Homepage AB set actions

export const ANLTX_AB_SET_TRIGGER = 'ANLTX_AB_SET_TRIGGER' as const;
export const ANLTX_AB_SET_SUCCESS = 'ANLTX_AB_SET_SUCCESS' as const;
export const ANLTX_AB_SET_FAILURE = 'ANLTX_AB_SET_FAILURE' as const;

export const anltxAbSet = {
  request: (feature: string, variant: string) => ({
    type: ANLTX_AB_SET_TRIGGER,
    feature,
    variant,
  }),
  success: (payload: { feature: string; variant: string; user_id: number; status: string }) => ({
    type: ANLTX_AB_SET_SUCCESS,
    payload,
  }),
  failure: (error: any) => ({
    type: ANLTX_AB_SET_FAILURE,
    error,
  }),
};

export type AnltxAbSetTriggerAction = ReturnType<typeof anltxAbSet.request>;
